<template>
  <div style="padding-top: 80px;">
    <TopNav activeIndex="2"></TopNav>
    <!-- <el-container class="course-container animated fadeIn" v-show="show">
        <div width="260px" class="left-course-container">
          <el-menu class="course-left-el-menu" default-active="1"  active-text-color="#ffffff"
              @select="handleSelect">
            <el-menu-item index="1">
              <i class="el-icon-document"></i>
              <span slot="title">Scratch启蒙</span>
            </el-menu-item>
            <el-menu-item index="2">
              <i class="el-icon-document"></i>
              <span slot="title">Scratch基础</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-document"></i>
              <span slot="title">Scratch进阶</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-document"></i>
              <span slot="title">Scratch挑战</span>
            </el-menu-item>
            <el-menu-item index="5">
              <i class="el-icon-document"></i>
              <span slot="title">Python人工智能基础</span>
            </el-menu-item>
            <el-menu-item index="6">
              <i class="el-icon-document"></i>
              <span slot="title">Python人工智能进阶</span>
            </el-menu-item>
            <el-menu-item index="7">
              <i class="el-icon-document"></i>
              <span slot="title">NOIP竞赛基础</span>
            </el-menu-item>
            <el-menu-item index="8">
              <i class="el-icon-document"></i>
              <span slot="title">NOIP竞赛进阶</span>
            </el-menu-item>
          </el-menu>
        </div>
      <Content></Content>
      <CourseProgress></CourseProgress>
    </el-container> -->
    <div class="header">
      <div class="header-container">
        <div class="herder-title">六大课程体系与STEAM结合</div>
        <div class="header-text">
          <p>适合3-16岁青少年自适应学习</p>
          <p>幼儿园到高中全覆盖，让孩子用编程改变未来</p>
        </div>
      </div>
    </div>
    <div class="kctx">
      <div class="kctx-container">
        <div class="text-container">
          <div class="b-title">科学完善的六大进阶式课程体系</div>
          <div class="b-line"></div>
          <div class="s-title">课程基于美国CSTA K-12
            CS标准，系统化的编程和英语课程核心教育，融合学校科技、技术、工程、艺术、数学等各门学科知识，充分发挥学生想象力和创造力，让孩子掌握未来全球通用的能力和技巧，提升孩子的创新和创造能力</div>
        </div>
        <img style=" margin-top:40px ; width: 798px;margin-bottom: 50px;" src="../../../static/images/kc2.png" />
        <!-- <div class="s-title">课程基于美国CSTA K-12
          CS标准，系统化的编程和英语课程核心教育，融合学校科技、技术、工程、艺术、数学等各门学科知识，充分发挥学生想象力和创造力，让孩子掌握未来全球通用的能力和技巧，提升孩子的创新和创造能力</div> -->
        <!-- <img style="" src="../../../static/images/class.png" /> -->
      </div>
    </div>
    <div class="qimengcode">
      <div class="qimengcode-container">
        <div class="text-container">
          <div class="kctx-title" style="background-color: #00A2E9; width: 200px;"> 启蒙编程</div>
          <div class="s-title">想象力，创造力，观察力，专注力，逻辑思维能力，沟通能力，团队协作能力</div>
          <div class="s-title">发现问题、分析问题和解决问题</div>
        </div>
        <img style="margin-top: 50px;" src="../../../static/images//jiantou.png">
        <div class="item-container">
          <div class="kctx-item " style="border: 1px solod #ff0000;">
            <div class="kctx-item-str">
              <p style="color: #009B4C;">场景搭建</p>
              <p>语言表达</p>
              <p>空间想象</p>
              <p>百科知识</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor1">
              <div>
                乐高主题式搭建，借助于专业的乐高教具，搭建与主题相符的作品，学习相关百科知识
              </div>
              <img src="../../../static/images/course/img16.jpg">
            </div>
          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #E40082;">百变工程</p>
              <p>工程机械</p>
              <p>结构与力</p>
              <p>团队协作</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor2">
              <div>
                理解杠杆、滑轮、齿轮、工程机械等物理相关的知识和技能，培养孩子的科学探索精神、团队协作能力、创作能力、动手能力
              </div>
              <img src="../../../static/images/course/img17.jpg">
            </div>

          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #00A2E9;">编程基础</p>
              <p>逻辑思维</p>
              <p>科学探索</p>
              <p>创新意识</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor3">
              <div>
                遥控编程启蒙学习训练，提升逻辑推理、认识智能、空间智能、数字小天地、综合能力，不断的激发探索科学的潜能
              </div>
              <img src="../../../static/images/course/img18.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rabot">
      <div class="rabot-container">
        <div class="text-container">
          <div class="kctx-title" style="background-color: #ACCE22; "> 机器人编程</div>
          <div class="s-title">机器人编程，适合3-9岁少儿启蒙编程。“玩中学”、“学中玩”，一边动手搭建积木，培养动手能力和专注力，一边编写代码，锻炼逻辑思维能力和解决问题的能力</div>
        </div>
        <img style="margin-top: 50px;" src="../../../static/images//jiantou.png">
        <div class="item-container">
          <div class="kctx-item ">
            <div class="kctx-item-str">
              <p style="color: #009B4C;">动力机械I</p>
              <p>WeDo机器人</p>
              <p>物理数学</p>
              <p>编程思维</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor1">
              <div>
                WeDo2.0让孩子充分认识机器人与编程的联系应用物理和数学，通过自己写的编程让机器人按照自己的指令做动作，锻炼思维能力，激发孩子兴趣和无限的可能
              </div>
              <img src="../../../static/images/course/img1.jpg">
            </div>
          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #E40082;">动力机械II</p>
              <p>EV3头脑风暴</p>
              <p>图形化编程</p>
              <p>综合应用</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor2">
              <div>
                Ev3，通过图形化编程，深度应用学到的编程知识，综合学习物理数学、机械电子、航空航天等多个领域的知识
              </div>
              <img src="../../../static/images/course/img2.jpg">
            </div>

          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #00A2E9;">机器人考级</p>
              <p>机器人竞赛</p>
              <p>WRO机器人比赛</p>
              <p>FLL机器人比赛</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor3">
              <div>
                组织参加全国青少年机器人考级考试、全国青少年机器人相关赛事，名校直接录取，让升学更有竞争力
              </div>
              <img src="../../../static/images/course/img3.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scratch">
      <div class="rabot-container">
        <div class="text-container">
          <div class="kctx-title" style="background-color: #009B4C; width: 280px;"> Scratch图形化编程</div>
          <div class="s-title">
            Scratch是由麻省理工学院推出的图形化编程工具软件，适合于全世界青少儿入门学习编程的工具，利用图形化界面，学习Scratch过程中形成编程思维，锻炼思维的逻辑性和完整性，为未来的发展提供更多的可能。</div>
        </div>
        <img style="margin-top: 50px;" src="../../../static/images//jiantou.png">
        <div class="item-container">
          <div class="kctx-item ">
            <div class="kctx-item-str">
              <p style="color: #009B4C;">基础模块了解</p>
              <p>顺序/循环/分支</p>
              <p>音乐/动画/造型</p>
              <p>游戏设计开发</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor4">
              <div>
                学习Scratch基础知识、了解积木编程的原理，完成动画、音乐、游戏，创作属于自己的项目作品，在创作中遇到问题到分析解决问题
              </div>
              <img src="../../../static/images/course/img4.jpg">
            </div>
          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #E40082;">四则运算</p>
              <p>空间几何</p>
              <p>数学物理</p>
              <p>算法思维</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor5">
              <div>
                强化数学物理知识、空间几何、思维算法的能力，把编程运用到各个学科中，在编程中玩数学、学物理，慢慢的提高其他学科的成绩
              </div>
              <img src="../../../static/images/course/img5.jpg">
            </div>

          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #00A2E9;">程序设计</p>
              <p>高级算法</p>
              <p>编程考级</p>
              <p>编程竞赛</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor6">
              <div>
                学习高级算法、AI思维对战，组织学生参加各类青少年编程等级考试和全国、省市的比赛，让升学更有竞争力
              </div>
              <img src="../../../static/images/course/img6.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="python">
      <div class="rabot-container">
        <div class="text-container">
          <div class="kctx-title" style="background-color: #F08519; width: 300px;">Python人工智能编程</div>
          <div class="s-title">Python是人工智能时代第一语言，也是大数据、机器学习、计算机视觉、物联网管理的必备语言</div>
          <div class="s-title">教育部规定学校应逐步加入中考、高考</div>
          <div class="s-title">提早学习，快别人一小步，将来的一大步</div>
        </div>
        <img style="margin-top: 50px;" src="../../../static/images//jiantou.png">
        <div class="item-container">
          <div class="kctx-item ">
            <div class="kctx-item-str">
              <p style="color: #009B4C;">基础语法</p>
              <p>循环判断</p>
              <p>数据处理</p>
              <p>海龟绘图</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor4">
              <div>
                学习Python编程语法，掌握Python中的循环、判断、数据结构、函数、逻辑算法、学习海龟库绘画出各种算法的图形
              </div>
              <img src="../../../static/images/course/img10.jpg">
            </div>
          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #E40082;">图像识别</p>
              <p>语音识别</p>
              <p>深度学习</p>
              <p>机器学习</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor5">
              <div>
                使用各种API，第三方库，深入学习人工智能技术，开发语音管家人脸识别、智能导航、机器学习、网站、爬虫等技术
              </div>
              <img src="../../../static/images/course/img11.jpg">
            </div>

          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #00A2E9;">综合应用</p>
              <p>人工智能</p>
              <p>编程考级</p>
              <p>编程竞赛</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor6">
              <div>
                基于面向对象的程序设计思路，综合运用所学知识，使用常见的设计模式，实操前沿技术，完成复杂度较高的应用程序和人工智能，组织学生参加各类青少年编程等级考试和全国、省市的比赛，让升学更有竞争力
              </div>
              <img src="../../../static/images/course/img12.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="javascript">
      <div class="rabot-container">
        <div class="text-container">
          <div class="kctx-title" style="background-color: #B04B87; width: 280px;">JavaScript编程</div>
          <div class="s-title">JavaScript是目前最主要的网站开发、游戏开发、应用程序、公众号、小程序、APP开发语言，提早学习JavaScript对孩子的综合能力，逻辑思维算法有更深层次的提高
          </div>
        </div>

        <img style="margin-top: 50px;" src="../../../static/images//jiantou.png">
        <div class="item-container">
          <div class="kctx-item ">
            <div class="kctx-item-str">
              <p style="color: #009B4C;">变量/方法/对象/类</p>
              <p>循环/事件/运算</p>
              <p> 数学/物理/算法</p>
              <p>多媒体游戏设计</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor1">
              <div>
                学习基础语法知识、数学物理知识、空间几何、角度方向坐标、四则运算、思维算法、开发简单的页面和游戏，能够充分发展孩子的数学思维、计算能力、设计能力
              </div>
              <img src="../../../static/images/course/img7.jpg">
            </div>
          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #E40082;">前端框架</p>
              <p>ＡＩ算法</p>
              <p>游戏开发</p>
              <p>应用开发</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor2">
              <div>
                学习前端框架、AI人机思维对战算法、小应用设计、h5小游戏开发，进一步提高孩子的各项综合能力
              </div>
              <img src="../../../static/images/course/img8.jpg">
            </div>

          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #00A2E9;">综合应用</p>
              <p>网站建设</p>
              <p>小程序开发</p>
              <p>APP开发</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor3">
              <div>
                综合能力全面提升，能够开发各项当前流行的微信小程序，APP软件，网站建设
              </div>
              <img src="../../../static/images/course/img9.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ccc">
      <div class="rabot-container">
        <div class="text-container">
          <div class="kctx-title" style="background-color: #7c6fb0; width: 280px;">C++ NOIP编程</div>
          <div class="s-title">以趣味编程为载体，通过完整、高效的解题训练课程，为对信息学有兴趣的学生提供施展才华的空间，培养学生的计算思维，让他们在人工智能时代有立足之本</div>
        </div>
        <img style="margin-top: 50px;" src="../../../static/images//jiantou.png">
        <div class="item-container">
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #009B4C;">基础语法</p>
              <p>数据结构</p>
              <p>循环判断</p>
              <p>数组算法</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor1">
              <div>
                学习C++基础语法、数据机构、循环判断、基础算法，了解编程思想
              </div>
              <img src="../../../static/images/course/img13.jpg">
            </div>
          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #E40082;">指针/队列/排序</p>
              <p>递归/多线程</p>
              <p>算法/字符串</p>
              <p>图像处理</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor2">
              <div>
                掌握指针、队列、排序、图像处理、人工智能各种算法，掌握奥信算法题型，独立运算算法思维解题
              </div>
              <img src="../../../static/images/course/img15.jpg">
            </div>

          </div>
          <div class="kctx-item">
            <div class="kctx-item-str">
              <p style="color: #00A2E9;">深度优化</p>
              <p>二叉树/搜索</p>
              <p>各种算法</p>
              <p>信息竞赛</p>
            </div>
            <div class="kctx-item-des kctx-item-bgClolor3">
              <div>
                真题实战、竞赛算法知识、刷题冲刺，录取名校
              </div>
              <img src="../../../static/images/course/img14.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import TopNav from '@/components/top/TopNav'
// import CourseProgress from './courseprogress'
// import Content from './content'
import Footer from '@/components/bottom/Footer'
import '../../css/animate.min.css'
export default {
  components: {
    TopNav,
    Footer
    // Content,
    // CourseProgress
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {},
  props: {},
  methods: {}
}

</script>

<style scoped src="./course.css">



// WEBPACK FOOTER //
// src/pages/course/course.vue